export default __webpack_public_path__ + "static/media/fb-pink.5281d8e6.svg";